import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f24d5c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = {
  class: "DialogBody",
  style: {"max-width":"none"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_6 = {
  key: 1,
  class: "DialogSection",
  style: {"flex-direction":"row"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "DialogSectionTitle" }
const _hoisted_10 = { class: "DialogSection" }
const _hoisted_11 = { class: "ItemSelector" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "ItemContent" }
const _hoisted_14 = { class: "F-Bold F1_5em" }
const _hoisted_15 = { class: "F-Bold" }
const _hoisted_16 = { class: "O-50" }
const _hoisted_17 = { class: "F-Bold" }
const _hoisted_18 = { class: "O-50" }
const _hoisted_19 = { class: "F-Bold" }
const _hoisted_20 = { class: "O-50" }
const _hoisted_21 = {
  key: 0,
  class: "F-Bold"
}
const _hoisted_22 = { class: "O-50" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "F-Bold F1_25em",
  style: {"color":"var(--colorr1)"}
}
const _hoisted_25 = { class: "O-50" }
const _hoisted_26 = { class: "F-Bold F1_25em" }
const _hoisted_27 = { class: "O-50" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AddButton" }, "+", -1))
const _hoisted_29 = { class: "CookiesRowSplitter P-Rel" }
const _hoisted_30 = {
  key: 0,
  style: {"bottom":"-3em"},
  class: "AddedItem Rad1 BGThird Shadow1"
}
const _hoisted_31 = { class: "Color2 F1_25em" }
const _hoisted_32 = { class: "DialogSectionTitle" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "scrollpoint",
  class: "CookiesRowSplitter"
}, null, -1))
const _hoisted_34 = { class: "DialogSection" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_36 = { class: "F-Bold M-Auto" }
const _hoisted_37 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_38 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDropDown = _resolveComponent("CookiesDropDown")!
  const _component_CookiesSearchInput = _resolveComponent("CookiesSearchInput")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.Saving)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.Loading.length > 0)
          ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.DialogData.Type === 'Import' || _ctx.DialogData.Type === 'ExternalImport')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2em F2em",
                  ID: ('ItemImport' as IconsIDs)
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.DialogData.Type === 'Export')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_CookiesIcon, {
                  class: "SQR2em F2em",
                  ID: ('Export' as IconsIDs)
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_7,
          _createVNode(_component_CookiesNormalInput, {
            Placeholder: _ctx.Translate('Vehicle Number'),
            Res: 'D_Transfer_ImportVehicleNumber'
          }, null, 8, ["Placeholder"]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.Translate('Select Items')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CookiesDropDown, {
              Name: _ctx.Translate('Brand'),
              Width: '40%',
              style: {"max-width":"80%"},
              Res: 'D_Transfer_Brand',
              Options: _ctx.FilteredBrands,
              Type: 'Object',
              Selector: 'Name'
            }, null, 8, ["Name", "Options"]),
            _createVNode(_component_CookiesDropDown, {
              Name: _ctx.Translate('Category'),
              Width: '40%',
              style: {"max-width":"80%"},
              Res: 'D_Transfer_Category',
              Options: _ctx.FilteredCategories,
              Type: 'Object',
              Selector: 'Name'
            }, null, 8, ["Name", "Options"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DecodedSpecs, (spec) => {
              return (_openBlock(), _createBlock(_component_CookiesDropDown, {
                key: spec,
                Name: _ctx.Translate(spec.Name),
                Width: '16%',
                style: {"max-width":"80%"},
                Res: 'D_Transfer_' + spec.Name,
                Options: spec.Description
              }, null, 8, ["Name", "Res", "Options"]))
            }), 128)),
            _createVNode(_component_CookiesSearchInput, {
              Placeholder: _ctx.Translate('Search...'),
              Res: 'D_Transfer_Search'
            }, null, 8, ["Placeholder"]),
            _createVNode(_component_CookiesIcon, {
              class: "SQR2em V-Auto",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ReadDialogData())),
              ID: ('Delayed' as IconsIDs)
            }),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FilteredItems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (_ctx.CheckItem(item)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(item.Item && item.Item.Code), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.CashedTranslations['Name']) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", null, _toDisplayString(item.Item && item.Item.Name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.CashedTranslations['Brand']) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", null, _toDisplayString(item.Item && item.Item.BrandName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.CashedTranslations['Category']) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", null, _toDisplayString(item.Item && item.Item.CategoryName), 1)
                    ]),
                    (_ctx.DialogData.Type === 'Export')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.CashedTranslations['Available']) + ":", 1),
                          _createTextVNode(),
                          (item.Item && item.Item.AvailableQuantity > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.Item && item.Item.AvailableQuantity), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.CashedTranslations['Not Available']), 1))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.Item && item.Item.Specifications, (spec) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "F-Bold",
                        key: spec
                      }, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.Translate(spec.Name)) + ":", 1),
                        _createTextVNode(),
                        _createElementVNode("span", null, _toDisplayString(spec.Description), 1)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.CashedTranslations['Pack Size']) + ":", 1),
                      _createTextVNode(),
                      _createElementVNode("span", null, _toDisplayString(item.PackSize), 1)
                    ])
                  ]),
                  _hoisted_28
                ], 8, _hoisted_12))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_29, [
              (_ctx.AddedItem)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, "+" + _toDisplayString(_ctx.Translate('Added')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.Translate('Items Received')), 1),
            _createVNode(_component_CookiesTable, {
              id: "TableToPrint2",
              onInputChanged: _ctx.SaveLocal,
              onFieldEdited: _ctx.SaveLocal,
              onShowLocations: _ctx.ShowLocations,
              CookiesInvalidInput: _ctx.TransferItems.length < 1,
              ErrorData: _ctx.ErrorsVisibilty && _ctx.TransferItems.length < 1,
              onDeleteRow: _ctx.RemoveItem,
              class: "Shadow1",
              TableSettings: _ctx.TableSettings,
              CookiesData: _ctx.TransferItems,
              Search: '',
              Loading: (_ctx.Loading.length > 0),
              Saving: (_ctx.SavingTable.length > 0),
              Saved: _ctx.Saved
            }, null, 8, ["onInputChanged", "onFieldEdited", "onShowLocations", "CookiesInvalidInput", "ErrorData", "onDeleteRow", "TableSettings", "CookiesData", "Loading", "Saving", "Saved"])
          ]),
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Note'),
              Res: 'D_Transfer_Note'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_35,
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printIT('TableToPrint2'))),
            class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT M-Auto F1_25em"
          }, [
            _createVNode(_component_CookiesIcon, {
              class: "V-Auto",
              style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
              ID: 'Printer'
            }),
            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.Translate('Print')), 1)
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access('Inventory_Transfers_Export') || _ctx.Access('Inventory_Transfers_Import') || _ctx.Access('Inventory_Transfers_Edit'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Close')), 1),
            _createElementVNode("button", {
              class: _normalizeClass([_ctx.TransferItems.length > 0 ? '' : 'Disabled', "F-Bold CookiesButton DialogFooterButton"]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main)
            }, _toDisplayString(_ctx.Translate('Import')), 7)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}